import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../core/animations';
import * as _ from 'lodash';

//Service file
import { AuthService } from '../../authentication/auth.service';
import { EcommerceOrdersService } from './orders.service';

/**Local file */
import { spekwo, login, toolTip, decodeData, marketsReports } from '../../utils/index';
import { ConfigurationService } from '../../configuration/configuration.service';

@Component({
  selector: 'orders-new',
  templateUrl: './orders-new.component.html',
  styleUrls: ['./orders-new.component.scss'],
  animations: fuseAnimations
})
export class OrdersNewComponent implements OnInit {

  spekwoValues = spekwo;
  loginValues = login;
  toolTipValues = toolTip;

  onRoleSubscription: Subscription;
  onCurrentTodoChanged: Subscription;

  currentUserName: string;
  currentUserChangedSubscription: Subscription;



  role: string;
  currentTodo: string;

  marketList: any[] = [];
  formValues = marketsReports;
  isLoader: boolean = false;

  constructor(
    public router: Router,
    /**Service file */
    public authService: AuthService,
    public ordersService: EcommerceOrdersService,
    public configurationService: ConfigurationService
  ) {
  }

  ngOnInit() {

    this.onRoleSubscription =
      this.authService.onCurrentUserChanged.subscribe(user => {

        this.role = user.roleByRoleId.roleName;

      });

    this.onCurrentTodoChanged =
      this.ordersService.onCurrentTodoChanged
        .subscribe(([currentTodo]) => {

          if (!currentTodo) {
            this.currentTodo = null;
          }
          else {
            this.currentTodo = currentTodo;
          }

        });

    this.currentUserChangedSubscription =
      this.authService.onCurrentUserChanged.subscribe(user => {
        this.currentUserName = user.firstName + ' ' + user.lastName;
      });
    this.getAllMarkets();
  }

  ngOnDestroy() {
    this.onRoleSubscription.unsubscribe();
    this.onCurrentTodoChanged.unsubscribe();
    this.currentUserChangedSubscription.unsubscribe();
  }

  /**Logout from app */
  logout() {

    window.localStorage.clear();
    this.router.navigate(['**']);

  }

  deSelectCurrentTodo() {
    this.ordersService.onCurrentTodoChanged.next([null]);
  }

  getAllMarkets() {
    this.isLoader = true;
    let marketList = [];
    this.configurationService.getMarket()
      .then((response) => {
        if (response && (response['nodes'] && response['nodes'].length > 0)) {
          response['nodes'].forEach((item) => {
            marketList.push({
              marketId: item && item.marketId ? item.marketId : "",
              marketName: item && item.marketName ? decodeData(item.marketName) : ""
            });
          });
          this.getlistOrderByMarkets(marketList);
        }
      });
  }

  getlistOrderByMarkets(marketList) {
    let orderByMarketList = [];
    marketList.map((eachMarket) => {
      setTimeout(() => {
        this.configurationService.getListOrderByMarket(eachMarket.marketId)
          .then((response) => {
            let approvedRepairsCount = 0;
            if (response && (response['nodes'] && response['nodes'].length > 0)) {
              response['nodes'].forEach((item) => {
                if (item && item.inspectionReportsSrcByOrderId && item.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId && item.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId.id) {
                  approvedRepairsCount = approvedRepairsCount + 1;
                }
              })
              orderByMarketList.push({
                marketId: eachMarket.marketId,
                marketName: eachMarket.marketName,
                quotesMtd: response['totalCount'],
                approvedRepairs: approvedRepairsCount,
                repairConversion: (approvedRepairsCount / response['totalCount']).toFixed(2) + "%"
              });
            }
            else {
              orderByMarketList.push({
                marketId: eachMarket.marketId,
                marketName: eachMarket.marketName,
                quotesMtd: 0,
                approvedRepairs: 0,
                repairConversion: 0 + "%"
              });
            }
            if (orderByMarketList.length == marketList.length) {
              this.isLoader = false;
              this.marketList = orderByMarketList;
              this.marketList = _.orderBy(this.marketList, [market => market.marketId], ['asc']);
            }
          }).catch(() => {
            this.isLoader = false;
          });
      }, 500);
    })
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/orders-new.component.ts